import { computed } from "vue";
import { useAntler } from "./antler-provider";
import type { ModalModule, ModalOptions } from "./modules/modal-module";

export function useModal() {
    const antlerProvider = useAntler();

    const modalModule = computed(() => {
        if (!antlerProvider) return undefined;
        return antlerProvider.getModule("modal") as ModalModule | undefined;
    });

    const openModal = (options: ModalOptions): string | undefined => {
        const module = modalModule.value;
        if (!module) {
            console.warn(
                "[useModal] Modal module not available when trying to open modal",
            );
            return undefined;
        }
        return module.openModal(options);
    };

    const closeModal = (id: string): void => {
        const module = modalModule.value;
        if (!module) {
            console.warn(
                "[useModal] Modal module not available when trying to close modal",
            );
            return;
        }
        module.closeModal(id);
    };

    const closeAllModals = (): void => {
        const module = modalModule.value;
        if (!module) {
            console.warn(
                "[useModal] Modal module not available when trying to close all modals",
            );
            return;
        }
        module.closeAllModals();
    };

    const updateModal = (id: string, options: Partial<ModalOptions>): void => {
        const module = modalModule.value;
        if (!module) {
            console.warn(
                "[useModal] Modal module not available when trying to update modal",
            );
            return;
        }
        module.updateModal(id, options);
    };

    return {
        modals: computed(() => modalModule.value?.modals.value || []),
        openModal,
        closeModal,
        closeAllModals,
        updateModal,
    };
}
